import React, { createContext, FC, ReactNode } from 'react'
import s from './Cover.module.sass'
import CoverMain from '@shared/ui/Layout/Cover/CoverMain'
import CoverAside from '@shared/ui/Layout/Cover/CoverAside'
import { ContainerLong } from '@shared/ui/Layout/Containers/ContainerLong'
import { ErrorBoundary } from '../../../lib/components/ErrorBoundary'

export const ImgContext = createContext('')

interface Props {
  img: string
  children: ReactNode
  classNameContainer?: string
  classNameContent?: string
}

const Cover: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  children,
  img,
  classNameContainer = '',
  classNameContent = '',
  ...props
}) => {
  return (
    <ErrorBoundary>
      <ImgContext.Provider value={img}>
        <ContainerLong
          tag={'section'}
          classNameContainer={`${s.container} ${classNameContainer}`}
          classNameContent={`${s.content} ${classNameContent}`}
          {...props}>
          {children}
        </ContainerLong>
      </ImgContext.Provider>
    </ErrorBoundary>
  )
}

const CoverNamespace = Object.assign(Cover, {
  Main: CoverMain,
  Aside: CoverAside,
})

export default CoverNamespace
